import { Plugin } from 'vuex';
import { IRootState, IStore } from '../store.types';
import * as Sentry from '@sentry/vue';

function sentryStoreInterceptor(store: IStore) {
  if (process.env.VUE_APP_ENABLE_LOGGING !== 'true') return;

  store.subscribeAction({
    after: action => {
      const actionType = action.type;
      const actionPayload = action.payload;

      if (actionType === 'auth/logout') {
        Sentry.setUser(null);
      }
    }
  });
}

export const sentryStorePlugin: Plugin<IRootState> = store => {
  sentryStoreInterceptor(store);
};
